import { trpc } from '@/shared/api/trpc';

export const useApplyHyperguestMatches = () => {
  const utils = trpc.useUtils();
  return trpc.hyperguestHotels.applyMatches.useMutation({
    onSettled: () => {
      utils.hyperguestHotels.find.invalidate();
      utils.hyperguestHotels.findMatched.invalidate();
      utils.hyperguestHotels.findUnconfirmed.invalidate();
      utils.hyperguestHotels.findProducts.invalidate();
    },
  });
};
